import styled from 'styled-components';

const FieldRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-end;
`;

export default FieldRow;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/FieldRow/index.jsx